export default (context, status) => {
    context.overlay = status
    context.menu = status
}